import Swup from 'swup';
import SwupBodyClassPlugin from '@swup/body-class-plugin';
// import SwupScriptsPlugin from '@swup/scripts-plugin';
// import Splide from '@splidejs/splide';
// import AOS from 'aos';
import Alpine from 'alpinejs'
import intersect from '@alpinejs/intersect'
import collapse from '@alpinejs/collapse'

import team from './components/team';
import portfolio from './components/portfolio';
import slider from './components/slider';

const swup = new Swup({
  plugins: [ 
    new SwupBodyClassPlugin(), 
    // new SwupScriptsPlugin() // this was causing alpine to reinit on each page multiple times
  ]
}); 

// Events
swup.on('contentReplaced', init);

Alpine.plugin(intersect)
Alpine.plugin(collapse)

// Start Apline after swup so it works correctly
window.Alpine = Alpine
Alpine.data('team', team)
Alpine.data('portfolio', portfolio)
Alpine.data('slider', slider)

Alpine.start();

document.addEventListener("DOMContentLoaded", () => init);

// Functions 
function l(m) { 
  console.log(m); 
}

function init() {
  l('👍');
  window.scroll(0,0);
}